const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'userPreferences':
      return { userPreferences: { ...state.userPreferences, ...action.data } };
    case 'error':
      return { error: action.error };
    default:
      return state;
  }
};

export default reducer;
